export class CampaignSummaryModel {
  constructor(item) {
    const {
      id,
      anLineItemId,
      name,
      status,
      menuType,
      menuName,
      unitType,
      unitPrice,
      creativeType,
      creativeCount,
      transactionProgress,
      campaignType,
      isCreatedOnAN,
      ownerProfileMenuId,
    } = item
    this.id = id
    this.anLineItemId = anLineItemId
    this.name = name
    this.status = status
    this.menuType = menuType
    this.menuName = menuName
    this.unitType = unitType
    this.unitPrice = unitPrice
    this.creativeType = creativeType
    this.creativeCount = creativeCount
    this.transactionProgress = transactionProgress
    this.campaignType = campaignType
    this.isCreatedOnAN = isCreatedOnAN
    this.ownerProfileMenuId = ownerProfileMenuId
  }

  static assign(data) {
    return new CampaignSummaryModel(data)
  }

  get isIncompleteTransaction() {
    return !this.isCreatedOnAN && this.transactionProgress < 5
  }

  get isCreativeSet() {
    return this.creativeCount > 0
  }
}
